import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import { IconButton, lighten } from '@mui/material'

interface ToggleSizeButtonProps {
  open: boolean
  setOpen: (open: boolean) => void
}

const ToggleSizeButton = (props: ToggleSizeButtonProps) => {
  const { open, setOpen } = props
  return (
    <IconButton
      disableRipple
      sx={{
        position: 'absolute',
        top: '50%',
        right: 0,
        transform: 'translate(52.5%, -50%)',
        '&:before': {
          content: '""',
          backgroundColor: (theme) => {
            return lighten(theme.palette.background.paper, 0.075)
          },
          border: (theme) => `1px solid ${theme.palette.divider}`,
          borderRadius: '25%',
          position: 'absolute',
          width: '60%',
          height: '60%',
          zIndex: -1,
        },
        '&:after': {
          content: '""',
          backgroundColor: (theme) => {
            return lighten(theme.palette.background.paper, 0.075)
          },
          position: 'absolute',
          left: '50%',
          width: '50%',
          height: '60%',
          transform: 'translateX(-100%)',
          zIndex: -1,
        },
        '& > *': {
          opacity: 0.5,
          transform: 'translateX(15%) scale(0.8)',
        },
      }}
      onClick={() => setOpen(!open)}
    >
      {open ? <ChevronLeft /> : <ChevronRight />}
    </IconButton>
  )
}

export default ToggleSizeButton
